import { render } from "./AdicionarRedeSocialClinica.vue?vue&type=template&id=764c2cfd&scoped=true"
import script from "./AdicionarRedeSocialClinica.vue?vue&type=script&lang=js"
export * from "./AdicionarRedeSocialClinica.vue?vue&type=script&lang=js"

import "./AdicionarRedeSocialClinica.vue?vue&type=style&index=0&id=764c2cfd&scoped=true&lang=css"

import exportComponent from "I:\\Centrion\\projetos\\aut_fri_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-764c2cfd"]])

export default __exports__